package org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashRegisterGlobal(
    @SerialName("apaleaoClientId")
    val apaleaoClientId: String?,
    @SerialName("apaleaoClientSecret")
    val apaleaoClientSecret: Boolean?,
    @SerialName("__typename")
    val typename: String?
)